<template>
  <div
    data-label
    :class="classList"
    tabindex="0"
    @click="handleClick"
    @keyup.enter="handleClick"
  >
    {{ label }}
  </div>
</template>

<script>
/**
 * Tab.vue
 */
export default {
  props: {
    label: {
      type: String,
      required: true,
    },

    active: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],

  data () {
    return {}
  },

  computed: {
    classList () {
      return [
        'px-4 py-4 whitespace-nowrap select-none flex-grow text-center transition-bg text-sm font-bold transition-all',
        this.active ? 'bg-blue-50 text-blue-500' : this.disabled ? 'text-gray-200' : 'text-gray-600',
        this.active ? 'shadow-inner-border-blue' : '',
        this.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
      ]
    },
  },

  methods: {
    handleClick () {
      if (!this.disabled) {
        this.$emit('click')
      }
    },
  },
}
</script>
